/* eslint-disable */

import axios from "axios";
import timezones from "compact-timezone-list";
import { make } from "vuex-pathify";
import moment from "moment-timezone";

const url = require("../../client_config/config").url;

const state = {
  items: [],
  timezones: timezones,
  defaultTZ: moment.tz.guess(),
};

const getters = {
  getTimezones: (state) => state.timezones,
  getUserTimezone: (state) => state.items.Timezone,
  getDefaultTz: (state) => {
    //temporary set default timezone base on user state
    //Override moment.guess() timezone and set timezone base on user state

    if (state.items.State === "Utah") {
      // MST/MDT
      return (state.defaultTZ = "America/Denver");
    } else if (state.items.State === "Nevada") {
      // PST/PDT
      return (state.defaultTZ = "America/Los_Angeles");
    } else {
      return state.defaultTZ;
    }
  },
};

const actions = {
  async fetchUser({ commit }) {
    try {
      let userID = localStorage.getItem("userID");
      const response = await axios.get(`${url}/users/${userID}`);
      // commit("SET_ALL", response.data.user.Timezone);
      commit("SET_ALL", response.data.user);
      return response;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },

  async updateTimezone({ commit }, data) {
    try {
      const response = await axios.put(`${url}/users/${data._id}`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },
};

const mutations = {
  ...make.mutations(state),
  SET_ALL(state, data) {
    state.items = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
